
import $ from 'jquery'
$(window).on("resize", function() {
  var width = $(window).width();
  console.log(width,"*****")
  var html = $("html");
  var fontS = width / 750;
  html.css("font-size", fontS + "px");
}).trigger("resize")